export default __webpack_public_path__ + "static/media/moderator.7915f4e6.md";